import { render, staticRenderFns } from "./UserViewUserPermissionsCard.vue?vue&type=template&id=6dc1cc2a&scoped=true&"
import script from "./UserViewUserPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./UserViewUserPermissionsCard.vue?vue&type=script&lang=js&"
import style0 from "./UserViewUserPermissionsCard.vue?vue&type=style&index=0&id=6dc1cc2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc1cc2a",
  null
  
)

export default component.exports